import * as R from 'ramda'
import P from 'helpers/predicates'


const greaterThanMin = value => R.compose(
  R.gte(value),
  R.prop('min')
)

const lessThanMax = value => R.compose(
  R.lte(value),
  R.prop('max')
)

const notBetweenMinMax = value => R.complement(
  R.both(
    greaterThanMin(value),
    lessThanMax(value)
  )
)

const notEmptyAndBetweenMinMax = (risks, value) => R.either(
  R.isEmpty,
  R.any(notBetweenMinMax(value))
)(risks)

const isRisk = R.curry((risks, value) => notEmptyAndBetweenMinMax(risks, value))

export default (risks) => [
  [isRisk(risks), 'Value is within risk range.']
]
